import React, { useEffect, useState } from "react";
import { PrivacyPolicyStyle } from "./style";
import { useNavigate } from "react-router-dom";

import arrowLeft from "../../images/bannersectionImages/arrowLeft.png";
import usehook from "./usehook";
const PrivacyPolicy = () => {
  const [policies, setPolicies] = useState([]);
  const { getAllPolicy } = usehook();

  const fetchedData = async () => {
    try {
      const res = await getAllPolicy();
      setPolicies(res);
    } catch (error) {}
  };

  useEffect(() => {
    fetchedData();
  }, []);

  const navigate = useNavigate();
  const backTo = () => {
    navigate("/");
  };

  return (
    <PrivacyPolicyStyle>
      <div className="d-flex p-4" style={{ cursor: "pointer" }}>
        <div className="" onClick={backTo}>
          <img src={arrowLeft} />
        </div>

        <div className="text-center m-auto">
          <h3>Privacy Policy</h3>
        </div>
      </div>
      {policies && policies.privacy_policy ? (
        <div className="p-4">
          <div dangerouslySetInnerHTML={{ __html: policies.privacy_policy }} />
        </div>
      ) : (
        <div className="text-center text-danger">No Record Found</div>
      )}
    </PrivacyPolicyStyle>
  );
};

export default PrivacyPolicy;
